import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
export const fieldAccessOptions = [
    {
        label: COPY_SPECIFIC.EDIT,
        value: COPY_SPECIFIC.EDIT
    },
    {
        label: COPY_SPECIFIC.READ_ONLY,
        value: COPY_SPECIFIC.READ_ONLY
    },
    {
        label: COPY_SPECIFIC.REQUIRED,
        value: COPY_SPECIFIC.REQUIRED
    }
];
